import { createContext, ReactNode, use, useEffect, useState } from "react";
import { useAuthStore } from "@/lib/Auth/authStore";
import { useOrgId } from "@/lib/GraphQLCodegen/fetcher";
import { createEcho, ReverbEcho } from "@/lib/Echo/createEcho";

const EchoContext = createContext<ReverbEcho | null>(null);

export function useEcho(): ReverbEcho | null {
  return use(EchoContext);
}

/**
 * One socket per signed-in organisation: channel authorisation rides on the
 * organisation header, so switching organisation reconnects.
 */
export function EchoProvider({ children }: { children: ReactNode }) {
  const token = useAuthStore((state) => state.token);
  const orgId = useOrgId();
  const [echo, setEcho] = useState<ReverbEcho | null>(null);

  useEffect(() => {
    const reverbUrl = import.meta.env.VITE_REVERB_URL;

    if (!token || !reverbUrl) {
      return;
    }

    const instance = createEcho(reverbUrl, token, orgId);
    setEcho(instance);

    return () => {
      instance.disconnect();
      setEcho(null);
    };
  }, [token, orgId]);

  return <EchoContext value={echo}>{children}</EchoContext>;
}
